module.exports = __webpack_public_path__ + "img/3.72d471d5.png";